import { c as _c } from "react/compiler-runtime";
import { identifyFacebookPixel } from '@/lib/facebook-pixel-identify';
import { useUser } from '@clerk/nextjs';
import { useEffect, useRef } from 'react';

/**
 * Re-initializes the Facebook Pixel with Advanced Matching (hashed email/phone)
 * once Clerk's user is loaded. Should be called once at the app root, inside
 * `<ClerkProvider>` so `useUser()` is available.
 *
 * Re-fires only when the email or phone changes (rare — typically once per session).
 */
export function useFacebookPixelIdentify() {
  const $ = _c(4);
  const {
    user,
    isLoaded
  } = useUser();
  const lastIdentifiedRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== isLoaded || $[1] !== user) {
    t0 = () => {
      if (!isLoaded || !user) {
        return;
      }
      const email = user.primaryEmailAddress?.emailAddress;
      const phone = (user.unsafeMetadata as Record<string, unknown>)?.phone_number as string | undefined;
      if (!email && !phone) {
        return;
      }
      const key = `${email ?? ""}|${phone ?? ""}`;
      if (lastIdentifiedRef.current === key) {
        return;
      }
      lastIdentifiedRef.current = key;
      identifyFacebookPixel({
        email,
        phone
      });
    };
    t1 = [isLoaded, user];
    $[0] = isLoaded;
    $[1] = user;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}